<div class="flex map flex column align-center" [ngClass]="{'content-full-screen': contentFillTheScreen}" *ngIf="mapLoaded">
  <google-map
    *ngIf="latitude && longitude"
    [center]="{lat: +latitude, lng: +longitude }"
    [zoom]="zoom"
    #trackingMap
    (zoomChanged)="handleZoomChanges()"
  >
    <app-map-clusterer *ngIf="avlReplay?.showIgnitions" icon="flash_on">
      <app-map-overlay
        *ngFor="let point of avlReplay.ignitions"
        [latitude]="point?.latitude"
        [longitude]="point?.longitude"
        [markerDraggable]="false"
        [title]="''"
      >
        <app-marker [size]="markerSize" style="transform: translate(-50%, -50%)">
          <app-icon
            [name]="point.ignition ? 'flash_on' : 'flash_off'"
            type="MaterialDesign"
            [ngClass]="'text-' + (point.ignition ? 'success' : 'error')"
          ></app-icon>
          1
        </app-marker>
      </app-map-overlay>
    </app-map-clusterer>

    <app-map-clusterer *ngIf="avlReplay?.showOverSpeed" icon="network_check">
      <app-map-overlay
        *ngFor="let point of avlReplay.overSpeed"
        [latitude]="point?.latitude"
        [longitude]="point?.longitude"
        [markerDraggable]="false"
        [title]="point.speed + 'km/hr'"
      >
        <app-avl-over-speed-marker
          [position]="point"
          [size]="markerSize"
          [activePopupId]="activeOverSpeedPositionId"
          (togglePopup)="showOverSpeedPopup($event)"
        ></app-avl-over-speed-marker>
      </app-map-overlay>
    </app-map-clusterer>

    <app-map-clusterer icon="local_parking" iconClass="text-error" *ngIf="avlReplay?.showStops">
      <app-map-overlay
        *ngFor="let point of avlReplay.stops"
        [latitude]="point?.latitude"
        [longitude]="point?.longitude"
        [markerDraggable]="false"
        [title]="''"
      >
        <app-shipment-stop-marker
          [position]="point"
          [size]="markerSize"
          [activePopupId]="activeStopPositionId"
          (togglePopup)="showStopPopup($event)"
        ></app-shipment-stop-marker>
      </app-map-overlay>
    </app-map-clusterer>

    <app-map-clusterer icon="route" iconClass="text-error" *ngIf="avlReplay?.showGateToGate">
      <app-map-overlay
        *ngFor="let point of avlReplay.gateToGate"
        [latitude]="point?.latitude"
        [longitude]="point?.longitude"
        [markerDraggable]="false"
        [title]="''"
      >
        <app-gate-to-gate-marker
          [position]="point"
          [zoom]="zoom"
          [activePopupId]="activeStopPositionId"
          (togglePopup)="showStopPopup($event)"
        ></app-gate-to-gate-marker>
      </app-map-overlay>
    </app-map-clusterer>

    <app-map-clusterer icon="assets/images/map/map-brake-icon.png" iconType="image" *ngIf="avlReplay?.showBrakes">
      <app-map-overlay
        *ngFor="let point of avlReplay?.brakes"
        [latitude]="point?.latitude"
        [longitude]="point?.longitude"
        [markerDraggable]="false"
        [title]="''"
      >
        <app-marker [size]="markerSize" style="transform: translate(-50%, -50%)">
          <img [src]="'assets/images/map/map-brake-icon.png'" />
        </app-marker>
      </app-map-overlay>
    </app-map-clusterer>

    <app-map-overlay
      [latitude]="currentPoint?.latitude || latitude"
      [markerDraggable]="false"
      [longitude]="currentPoint?.longitude || longitude"
      *ngIf="currentPoint"
    >
      <div class="overlay" style="transform: translate(-25%, -25%)">
        <div class="layer-one" [class.unavailable]="currentPoint.shipmentId">
          <div class="layer-two" [class.unavailable]="currentPoint.shipmentId">
            <div class="image flex justify-center align-center">
              <app-icon
                name="bold-driver"
                (click)="currentPoint.selected = !currentPoint.selected"
                [ngClass]="{
                'text-danger': currentPoint.shipmentId,
                'text-success': !currentPoint.shipmentId
              }"
                size="lg"
              ></app-icon>
            </div>
          </div>

          <div class="data flex column" *ngIf="currentPoint.selected">
            <div class="flex status align-center justify-space-between">
              <p *ngIf="+currentPoint.shipmentId" class="unavailable radius-1 small weight-medium">{{'Providers.Drivers.Unavailable' | translate}}</p>
              <p *ngIf="!+currentPoint.shipmentId" class="available radius-1 small weight-medium">{{'Providers.Drivers.Available' | translate}}</p>
              <img src="../../../../../assets/images/close.svg" class="close-icon" (click)="currentPoint.selected = !currentPoint.selected" />
            </div>
            <div *ngIf="currentPoint.shipmentId">
              <mat-divider class="my-2"></mat-divider>
            </div>
            <div class="shipment m-0" *ngIf="currentPoint.shipmentId">
              <p class="small m-0 mb-2">
                <span class="card-title">{{'Providers.Drivers.ShipmentId' | translate}}</span>
              </p>

              <p class="small m-0">
                <a
                  class="card-title"
                  [routerLink]="routesUtil.ShipmentsViewWithoutRange.url({ id: currentPoint.shipmentId, type: ShipmentsListType.All })"
                  target="_blank"
                >
                  {{currentPoint.shipmentId? '( '+currentPoint.shipmentId+ ')':'_______'}}
                </a>
              </p>
            </div>
            <div *ngIf="currentPoint.truck">
              <mat-divider class="my-2"></mat-divider>
            </div>
            <div *ngIf="currentPoint.truck" class="flex column truck">
              <ng-container *ngIf="currentPoint.truck?.id">
                <app-row>
                  <app-col cols="6" [ngClass]="{'mb-2':currentPoint.truck?.brand||currentPoint.nationality}" *ngIf="currentPoint.truck?.plateNumber">
                    <span class="text-400 small">{{'Providers.Drivers.Plate' | translate}}</span>
                    <p class="font-size-xs weight-normal text-800">{{currentPoint.truck?.plateNumber}}</p>
                  </app-col>
                  <app-col cols="6" [ngClass]="{'mb-2':currentPoint.truck?.brand||currentPoint.nationality}" *ngIf="currentPoint.truck?.type">
                    <span class="text-400 small">{{'Providers.VehicleType' | translate}}:&nbsp;</span>
                    <p class="font-size-xs weight-normal text-800">{{currentPoint.truck?.type?.name}}</p>
                  </app-col>
                  <app-col cols="6" *ngIf="currentPoint.truck?.brand">
                    <span class="text-400 small">{{'Providers.Drivers.TruckBrand' | translate}}</span>
                    <p class="font-size-xs weight-normal text-800">{{currentPoint.truck?.brand.name }}</p>
                  </app-col>
                  <app-col cols="6" *ngIf="currentPoint.nationality">
                    <span class="text-400 small">{{'Providers.Drivers.Country' | translate}}:&nbsp;</span>
                    <p class="font-size-xs weight-normal text-800">{{currentPoint.nationality}}</p>
                  </app-col>
                </app-row>
              </ng-container>

              <div class="flex select" *ngIf="showSelectButton">
                <button (click)="selectDriver()">{{'Buttons.Select' | translate}}</button>
              </div>
            </div>

            <div *ngIf="currentPoint.driverId">
              <mat-divider class="my-2"></mat-divider>
            </div>
            <app-row>
              <div class="flex align-center">
                <div class="mr-2" *ngIf="currentPoint?.user && currentPoint.user?.name">
                  <app-avatar bgColor="transparent" src="/assets/images/driver-image-placeholder.svg" [round]="true"></app-avatar>
                </div>
                <div>
                  <div *ngIf="currentPoint?.user && currentPoint.user?.name">
                    <p class="weight-semibold m-0 card__content-subtxt mb-1">{{currentPoint.user?.name}}</p>
                  </div>

                  <div class="flex" *ngIf="currentPoint.user && currentPoint.user?.mobileNumber">
                    <span class="card-title">{{'LiveTracking.Driver.PhoneNo' | translate}}.{{currentPoint.user?.mobileNumber}}</span>
                  </div>

                  <div class="flex" *ngIf="currentPoint.date">
                    <span class="card-title">{{'Providers.Drivers.LocationDate' | translate}}:&nbsp;</span>
                    <p class="card-title m-0">{{ currentPoint.date | date: 'MMM d, y, h:mm:ss a' }}</p>
                  </div>
                </div>
              </div>
            </app-row>
            <div *ngIf="currentPoint.driverId||currentPoint.shipmentI">
              <mat-divider class="my-2"></mat-divider>
            </div>
            <div>
              <p *ngIf="truck?.shipmentId||truck?.driver" class="small weight-medium w-100 text-900 m-0 mb-2">
                {{'LiveTracking.VisitProfiles' | translate}}
              </p>
              <div class="flex align-center flex-wrap">
                <div *ngIf="currentPoint.shipmentId">
                  <a
                    class="btn-enhanced radius-1 border-1 flex align-center small py-2 px-4 text-primary mr-1"
                    [routerLink]="routesUtil.ShipmentsViewWithoutRange.url({ id: currentPoint.shipmentId, type: ShipmentsListType.All })"
                    target="_blank"
                  >
                    <app-icon name="box" class="mr-2" size="xs"></app-icon>
                    {{'LiveTracking.Shipment' | translate}}
                  </a>
                </div>
                <div *ngIf="currentPoint.driverId">
                  <a
                    class="btn-enhanced radius-1 border-1 flex align-center small py-2 px-4 text-primary mr-1"
                    [routerLink]="routesUtil.FleetsDriversView.url({ id: currentPoint.driverId })"
                    target="_blank"
                  >
                    <app-icon name="driver" class="mr-2" size="xs"></app-icon>
                    {{'LiveTracking.Driver' | translate}}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-map-overlay>

    <app-map-overlay
      *ngIf="pickupCoordinate"
      [latitude]="pickupCoordinate?.latitude"
      [longitude]="pickupCoordinate?.longitude"
      [markerDraggable]="false"
      [title]="'Start'"
    >
      <app-marker color="primary" size="md" style="transform: translate(-50%, -50%)" [matTooltip]="'LiveTracking.Start' | translate">
        <div class="flex align-center justify-center icon-layer">
          <app-icon name="warehouse" size="xs" class="text-white"></app-icon>
        </div>
      </app-marker>
      <map-info-window *ngIf="showCoordinateInfo">
        <div class="map-info-window-content madar--v2">
          <a [routerLink]="routesUtil.ShipmentsViewWithoutRange.url({ id: shipmentId, type: ShipmentsListType.All })">
            <div class="flex align-center justify-space-between mb-2">
              <div>
                <h5 class="text-900 small m-0">{{"Shipments.CompanyShipperInformation" | translate}}</h5>
                <div class="flex mb-1 align-center">
                  <span class="shipment-id-label">{{"Shipments.ShipmentId" | translate}}:</span>
                  <span p class="text-accent small m-0">{{shipmentId}}</span>
                </div>
              </div>
              <app-icon name="chevron_right" [type]="IconType.MaterialDesign" class="text-500"></app-icon>
            </div>
          </a>
          <div class="property-container flex column justify-flex-start align-flex-start">
            <h6 class="text-600 mb-1 small">{{'Shipments.PickupLocation' | translate}}</h6>
            <span class="small text-400">{{pickupAddress}}</span>
          </div>
        </div>
      </map-info-window>
    </app-map-overlay>

    <app-map-overlay
      *ngIf="dropOffCoordinate"
      [latitude]="dropOffCoordinate?.latitude"
      [longitude]="dropOffCoordinate?.longitude"
      [markerDraggable]="false"
      [title]="'Destination'"
    >
      <app-marker color="primary" size="md" style="transform: translate(-50%, -50%)" [matTooltip]="'LiveTracking.Destination' | translate">
        <div class="flex align-center justify-center icon-layer">
          <app-icon name="flag" size="xs" class="text-white"></app-icon>
        </div>
      </app-marker>
      <map-info-window *ngIf="showCoordinateInfo">
        <div class="map-info-window-content madar--v2">
          <a [routerLink]="routesUtil.ShipmentsViewWithoutRange.url({ id: shipmentId, type: ShipmentsListType.All })">
            <div class="flex align-center justify-space-between mb-2">
              <div>
                <h5 class="text-900 small m-0">{{"Shipments.ReceiverInformation" | translate}}</h5>
                <div class="flex mb-1 align-center">
                  <span class="shipment-id-label">{{"Shipments.ShipmentId" | translate}}:</span>
                  <span class="text-accent small m-0">{{shipmentId}}</span>
                </div>
              </div>
              <app-icon name="chevron_right" [type]="IconType.MaterialDesign" class="text-500"></app-icon>
            </div>
          </a>
          <div class="property-container flex column justify-flex-start align-flex-start">
            <h6 class="text-600 mb-1 small">{{'Shipments.Drop-offLocation' | translate}}</h6>
            <span class="small text-400">{{dropOffAddress}}</span>
          </div>
        </div>
      </map-info-window>
    </app-map-overlay>

    <map-polyline
      *ngIf="viewedRoutes.BEFORE_START && (beforeTripPoints | LatLng) as path"
      [options]="{strokeColor: '#e23938', strokeWeight: truckPoints?.length ? 7 : null }"
      [path]="path"
    ></map-polyline>

    <map-polyline
      *ngIf="viewedRoutes.AFTER_START && (tripPoints | LatLng) as path"
      [options]="{ strokeColor: '#2f5cbd', geodesic: true, strokeWeight: truckPoints?.length ? 7 : null  }"
      [path]="path"
    ></map-polyline>

    <map-polyline
      *ngIf="viewedRoutes.STANDALONE && (truckPoints | LatLng) as path"
      [options]="{ strokeColor: '#5eca00', geodesic: true }"
      [path]="path"
    ></map-polyline>
  </google-map>

  <div class="map-actions p-2" style="width: 0">
    <app-row gutter="xs" class="wrap">
      <app-col>
        <div class="flex">
          <button
            mat-icon-button
            [matTooltip]="'LiveTracking.ShipmentBeforeArrival' | translate"
            matTooltipPosition="above"
            type="button"
            class="mr-2"
            [ngStyle]="{backgroundColor: '#e23938', color: 'white'}"
            (click)="toggleRoute('BEFORE_START')"
          >
            <app-icon [name]="viewedRoutes.BEFORE_START ? 'visibility_off' : 'visibility'" type="MaterialDesign"></app-icon>
          </button>
          <button
            mat-icon-button
            [matTooltip]="'LiveTracking.ShipmentAfterArrival' | translate"
            matTooltipPosition="above"
            type="button"
            class="mr-2"
            [ngStyle]="{backgroundColor: '#2f5cbd', color: 'white'}"
            (click)="toggleRoute('AFTER_START')"
          >
            <app-icon [name]="viewedRoutes.AFTER_START ? 'visibility_off' : 'visibility'" type="MaterialDesign"></app-icon>
          </button>
          <button
            *ngIf="truckPoints?.length"
            mat-icon-button
            [matTooltip]="'LiveTracking.TruckView' | translate"
            matTooltipPosition="above"
            type="button"
            class="mr-2"
            [ngStyle]="{backgroundColor: '#5eca00', color: 'white'}"
            (click)="toggleRoute('STANDALONE')"
          >
            <app-icon [name]="viewedRoutes.STANDALONE ? 'visibility_off' : 'visibility'" type="MaterialDesign"></app-icon>
          </button>
        </div>
      </app-col>
    </app-row>
  </div>
</div>
